import { DASHBOARD_BASE_PATH } from '@/config/baseModulesLink.tsx';

export const PROFILE_PATH = 'profile';
export const ABOUT_US_PATH = 'about-us';
export const SIGNATURE_PATH = 'signature';
export const WALLET_PATH = 'wallet';
export const YEARLY_REPORT = 'yearly-report';

export const DASHBOARD_LINKS = {
  homePage: `/${DASHBOARD_BASE_PATH}`,
  profile: `/${PROFILE_PATH}`,
  aboutUs: `/${DASHBOARD_BASE_PATH}/${ABOUT_US_PATH}`,
  signature: `/${DASHBOARD_BASE_PATH}/${SIGNATURE_PATH}`,
  wallet: `/${DASHBOARD_BASE_PATH}/${WALLET_PATH}`,
  walletYearlyReport: `/${DASHBOARD_BASE_PATH}/${WALLET_PATH}/${YEARLY_REPORT}`,
};
